import React from 'react';
import { SectionAttention as Styled } from '../../styles/about';

/**
 * 運営方針
 */
const SectionPolicy: React.FC = () => {
  return (
    <Styled id="policy">
      <h3>
        <span>運営方針</span>
      </h3>
      <p>
        ナース専科 コミュニティはその質の高さ、社会的貢献度の高さにおいて誰からも敬意の念をもって認められる場にしたいと思っております。
        倫理観を保った建設的な議論の場として活用されるよう、当掲示板を利用される看護師のみなさんひとりひとりのご協力をお願いいたします。
      </p>
      <p>上記、「ルール」「注意事項」についてご認識の上、投稿時にはご注意をお願いいたします。</p>
    </Styled>
  );
};

export default SectionPolicy;
